export const AUTH_TOKEN = "auth_token_sincron";
export const REFRESH_TOKEN = "refresh_token_sincron";
export const AUTH_STORAGE = "auth-storage-sincron";
export const USER_ID = "user_id_sincron";
export const USER = "user_sincron";
export const THEME_SINCRON = "theme_sincron";
